const footerLinks = [
  {
    title: 'Company',
    links: [
      { title: 'About', link: '/about' },
      { title: 'Careers', link: '/careers' },     /*carrers ---> /careers ----> (provide link in /careers)*/
      { title: 'Affiliates', link: '/affiliates' },
    ]
  },



  {
    title: 'Resources',
    links: [
      { title: 'Articles', link: '/articles' },
      { title: 'Blog', link: '/blog' },
      { title: 'Chart Sheet', link: 'https://roadmap.sh/' },
      { title: 'Code Challenges', link: 'https://www.codechef.com/' },
      //{ title: 'Docs', link: '/docs' },
      { title: 'Projects', link: 'https://dhruvabhattacharya.github.io' },
      { title: 'Videos', link: 'https://www.youtube.com/watch?v=Vha0J9FiqU4&list=PLb2gU_PLly1C52N-MYC_-58Mi4h24gyHN&pp=gAQBiAQB' },
      //{ title: 'Workspaces', link: '/workspaces' },
    ]
  },

  {
    title: 'Support',
    links: [
      { title: 'Help Center', link: '/help-center' },
    ]
  },

  {
    title: 'Plans',
    links: [
      { title: 'Paid Membership', link: '/paid-membership' },
      { title: 'For Students', link: '/for-students' },
      { title: 'Business Solutions', link: '/business-solutions' },
    ]
  },

  {
    title: 'Community',
    links: [
      { title: 'Forums', link: '/forums' },
      { title: 'Chapters', link: '/chapters' },
      { title: 'Events', link: '/events' },
    ]
  },

  {
    title: "Subjects",
    links: [
      { title: "AI", link: "https://kdb.ai/" },
      { title: "Cloud Computing", link: "https://aws.amazon.com" },
      { title: "Code Foundations", link: "https://www.codecademy.com/learn/paths/code-foundations" },
      { title: "Computer Science", link: "/https://www.geeksforgeeks.org" },
      { title: "Cybersecurity", link: "https://www.ibm.com/topics/cybersecurity" },
      { title: "Data Analytics", link: "https://aws.amazon.com/what-is/data-analytics/#:~:text=Data%20analytics%20converts%20raw%20data,making%2C%20and%20foster%20business%20growth." },
      { title: "Data Science", link: "https://roadmap.sh/ai-data-scientist" },
      { title: "Blockchain", link: "https://roadmap.sh/blockchain" },
      { title: "DevOps", link: "https://whimsical.com/devops-7E37RVStMQycbbJYjfM77P" },
      { title: "Game Development", link: "https://roadmap.sh/game-developer" },
      //{ title: "IT", link: "/it" },
      { title: "Machine Learning", link: "https://www.javatpoint.com/machine-learning" },
      { title: "Math", link: "https://www.geeksforgeeks.org/maths-for-data-science/" },
      { title: "Mobile Development", link: "https://roadmap.sh/react-native" },
      //{ title: "Web Design", link: "/web-design" },
      { title: "Web Development", link: "https://whimsical.com/web-development-roadmap-Hqgk6FpFEpcvB7s3ZqGnxV" },
    ],
  },
  {
    title: "Languages",
    links: [
      { title:"Unity",link:"https://docs.unity.com/"},
      { title: "Bash", link: "https://devdocs.io/bash/" },
      { title: "C++", link: "https://cplusplus.com/doc/" },
      { title: "C#", link: "https://learn.microsoft.com/en-us/dotnet/csharp/" },
      { title: "Go", link: "https://go.dev/doc/" },
      { title: "HTML & CSS", link: "https://developer.mozilla.org/en-US/docs/Learn/CSS" },
      { title: "Java", link: "https://docs.oracle.com/en/java/" },
      { title: "JavaScript", link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript" },
      { title: "Kotlin", link: "https://kotlinlang.org/docs/home.html" },
      { title: "PHP", link: "https://www.php.net/docs.php" },
      { title: "Python", link: "https://docs.python.org/3/" },
      { title: "R", link: "https://www.r-project.org/other-docs.html" },
      { title: "Ruby", link: "https://www.ruby-lang.org/en/documentation/" },
      { title: "SQL", link: "https://dev.mysql.com/doc/" },
      { title: "Swift", link: "https://www.swift.org/documentation/" },
      
    ],
  },
  {
    title: "Career building",
    links: [
      { title: "SDE Sheet", link: "https://drive.google.com/file/d/1FMdN_OCfOI0iAeDlqswCiC2DZzD4nPsb/view" },
      // { title: "Career paths", link: "/career-paths" },
      // { title: "Career services", link: "/career-services" },
      { title: "Interview prep", link: "https://takeuforward.org/interviews/most-trusted-90-days-roadmap-to-placement-guaranteed/" },
      
      //{ title: "-", link: "/" },
      //{ title: "Full Catalog", link: "/full-catalog" },
      //{ title: "Beta Content", link: "/beta-content" }
    ]
  }
];

module.exports = footerLinks;
